module.exports = __webpack_public_path__ + "media/images/demo_tests/skyscrapper-d22064b4e88a41c307178bfec3ac9a12.gif";